<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc-fm"><a href="#/xhtml/05_Preface"><em class="italic">Preface</em></a></h2>
<h2 class="toc-fm"><a href="#/xhtml/06_Timeline"><em class="italic">Timeline</em></a></h2>
<h2 class="toc-fm"><a href="#/xhtml/07_Maps"><em class="italic">Maps</em></a></h2>
<h2 class="toc-chap"><a href="#/xhtml/08_Chapter01"><span class="toc"><span class="bold">Chapter 1</span></span> The Forebears 1000–1199</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/09_Chapter02"><span class="toc"><span class="bold">Chapter 2</span></span> The Fourth Crusade 1200–1205</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 3</span></span> Inheritance and Heresy 1206–1209</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 4</span></span> Lest Your Foot Stumble on a Stone 1209–1211</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 5</span></span> North versus South 1211–1213</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 6</span></span> Supremacy 1213–1216</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 7</span></span> Twilight of the Albigensian Crusade 1217–1229</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 8</span></span> New Lords in the Family 1230–1241</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 9</span></span> More Crusades and Political Undertakings 1242–1254</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 10</span></span> Realpolitik and Revolution 1254–1263</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><span class="toc"><span class="bold">Chapter 11</span></span> Tried and Tested in the World 1264–1300</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/19_Appendix" title="Link target outside of Sample"><em class="italic">Appendix: Seals of the de Montforts</em></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/20_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/22_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
<h2 class="toc-fm"><span href="#/xhtml/23_Illustrations" title="Link target outside of Sample"><em class="italic">List of Illustrations</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?13a919be